// extracted by mini-css-extract-plugin
export default {"indicator":"ActivityNotificationUnseenIndicator_indicator__L4ZF1"};